export default __webpack_public_path__ + "static/media/twitter-icon.9364e2ed.svg";